<template>
  <b-card
    class="media-card"
    v-bind:class="{ 'media-card-music': media_type == 'music',
    'media-card-dy': client_name=='DY',
    'media-card-mid': client_name=='MID',
     }"
    no-body
    footer-class="mx-2 mb-1"
    
  >
    <template #header v-if="media_type == 'music'">
      <img
        v-if="music_type == 'spotify' && client_name == 'DY'"
        src="@/assets/images/doom-yoga/spotify-icon.png"
        class="media-icon"
      /><img
        v-if="music_type == 'spotify' && client_name == 'MID'"
        src="@/assets/images/my-irish-date/spotify-logo.png"
        class="media-icon"
      />
      <img
        v-if="music_type == 'mp3'"
        src="@/assets/images/doom-yoga/music-icon.png"
        class="media-icon"
      />
    </template>
    <b-card-img
      v-if="img_src != null && img_src != ''"
      :src="img_src"
    >
    </b-card-img>
    <img
      v-else-if="(img_src==null || img_src == '') && client_name =='DY'"
      src="@/assets/images/doom-yoga/doomyoga-music.png"
      class="card-img-top"
    /> 
    <img
      v-else-if="(img_src==null || img_src == '') && client_name =='MID'"
      src="@/assets/images/my-irish-date/mid-icon.png"
      class="card-img-top"
    />
    <img
      v-if="media_type == 'video'"
      src="@/assets/images/doom-yoga/video-icon.png"
      class="play-image"
    />
    <img
      v-if="media_type == 'audio'"
      src="@/assets/images/doom-yoga/audio-icon.png"
      class="play-image"
    />
    <template #footer>
      <div>
        <h4 class="mediaTitleH4">{{ title }}</h4>
        <h6 class="mediaDurationH6">{{ duration }}</h6>
      </div>
    </template>
  </b-card>
</template>

<script>
export default {
  name: "MediaCard",
  props: [
    "client_name",
    "title",
    "duration",
    "img_src",
    "media_type",
    "music_type",
    "media_type",
  ],
  data() {
    return {};
  },
};
</script>



// WEBPACK FOOTER //
// src/components/media_components/MediaCard.vue